exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mobile-carousel__container__13BgB{position:relative;overflow:hidden;-ms-touch-action:pan-y pinch-zoom;touch-action:pan-y pinch-zoom}.mobile-carousel__slick-track__5QJA1{display:-ms-flexbox;display:flex}", ""]);

// exports
exports.locals = {
	"container": "mobile-carousel__container__13BgB",
	"slick-track": "mobile-carousel__slick-track__5QJA1",
	"slickTrack": "mobile-carousel__slick-track__5QJA1"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/mobile-carousel/mobile-carousel.styl
// module id = 2913
// module chunks = 1